/**
 * ResetSessionButton — escape hatch when the browser carries stale
 * auth/impersonation state that the app can't recover from. Clears
 * every DACcelerate-namespaced key in localStorage and reloads to
 * /login. Visible in the header for every logged-in user.
 */

import { Button, Tooltip } from '@fluentui/react-components'
import { ArrowReset20Regular } from '@fluentui/react-icons'
import { IMPERSONATE_STORAGE_KEY, TOKEN_STORAGE_KEY } from '../lib/constants'

const KEYS_TO_CLEAR = [
  TOKEN_STORAGE_KEY,
  IMPERSONATE_STORAGE_KEY,
  'daccelerate_v2_show_test_data',
  'token', // legacy key
]

export function ResetSessionButton() {
  function reset() {
    for (const k of KEYS_TO_CLEAR) {
      try {
        localStorage.removeItem(k)
      } catch { /* ignore */ }
    }
    window.location.href = '/login'
  }

  // "Sign out" is the word people look for; this button was the only way out
  // and did not carry it (#1378). What it does is unchanged.
  return (
    <Tooltip content="Sign out — clears your login and any impersonation" relationship="label">
      <Button
        appearance="subtle"
        size="small"
        icon={<ArrowReset20Regular />}
        onClick={reset}
        aria-label="Sign out"
      />
    </Tooltip>
  )
}
